export const s3ImageLink = 'https://website-resource.ahaglobal.io/ads-platform/';
